import { createFileRoute } from "@tanstack/react-router"

import { SharePublicSelectionsPage } from "@/pages/share/share-public-selections-page"

export const Route = createFileRoute("/share/selections/$token")({
	component: SharePublicSelectionsPage,
})
